import { Outlet, useLocation } from 'react-router-dom';
import { AdminNav } from '../../components/Admin/AdminNav';
import { AdminSidebar } from '../../features/admin-v2/components/admin-sidebar';
import { Auth0ProviderWithNavigate } from '../../auth0-provider';

/**
 * Layout component for admin pages, includes admin navigation
 */
export const AdminLayout = () => {
  const location = useLocation();
  const isAdminV2 = location.pathname.startsWith('/admin-v2');
  const isAdminV2Fullscreen =
    isAdminV2 &&
    location.pathname.endsWith('/rcm-scoreboard') &&
    new URLSearchParams(location.search).get('fullscreen') === '1';
  // Org and provider detail pages are "workspace takeovers": their own nav
  // rail replaces the global sidebar (the rail carries an "← Admin v2" exit).
  const isEntityWorkspace =
    isAdminV2 && /^\/admin-v2\/(organization|provider)\/[^/]+\/?$/.test(location.pathname);

  if (isAdminV2) {
    return (
      <Auth0ProviderWithNavigate>
        <div className="flex bg-gray-50 overflow-hidden" style={{ height: '100%' }}>
          {!isAdminV2Fullscreen && !isEntityWorkspace && <AdminSidebar />}
          <main className="flex-1 overflow-auto relative">
            <Outlet />
          </main>
        </div>
      </Auth0ProviderWithNavigate>
    );
  }

  return (
    <Auth0ProviderWithNavigate>
      <AdminNav />
      <main className="p-4">
        <Outlet />
      </main>
    </Auth0ProviderWithNavigate>
  );
};
